import { createContext } from 'react';

export interface VirtualElement {
  height: number;
  width: number;
  x: number;
  y: number;
}

export type StickyContextValue = {
  id: string;
  parent: StickyContextValue | null;
  container: VirtualElement;
};

export const StickyContext = createContext<StickyContextValue | null>(null);
